import { __assign, __rest } from "tslib";
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Position } from '@marvelapp/ui';
function DashboardBoxFullWidth(_a) {
    var children = _a.children, hasSidebar = _a.hasSidebar, isInDesignMode = _a.isInDesignMode, sidebarWidth = _a.sidebarWidth, props = __rest(_a, ["children", "hasSidebar", "isInDesignMode", "sidebarWidth"]);
    var _b = useMemo(function () {
        var widthWithSidebar = "calc(100vw - ".concat(sidebarWidth, "px)");
        var leftWithSidebar = "calc(50% + ".concat(sidebarWidth / 2, "px)");
        var leftBit = hasSidebar ? ['50%', '50%', '50%', leftWithSidebar] : '50%';
        var widthBit = hasSidebar
            ? ['100vw', '100vw', '100vw', widthWithSidebar]
            : ['80vw', '100vw', '100vw', '100vw'];
        var marginLeftBit = ['-50vw', '-50vw', '-50vw', '-50vw'];
        return { left: leftBit, width: widthBit, marginLeft: marginLeftBit };
    }, [hasSidebar, sidebarWidth]), left = _b.left, marginLeft = _b.marginLeft, width = _b.width;
    if (isInDesignMode) {
        return children;
    }
    return (React.createElement(Position, __assign({ left: left, ml: marginLeft, position: "relative", width: width }, props), children));
}
DashboardBoxFullWidth.propTypes = {
    children: PropTypes.node,
    hasSidebar: PropTypes.bool,
    sidebarWidth: PropTypes.number,
};
DashboardBoxFullWidth.defaultProps = {
    hasSidebar: true,
};
export default DashboardBoxFullWidth;
